import React, { useEffect, useState } from "react";
import styled from "styled-components";

import { useLanguage } from "../../Context/LanguageContext";
import { useTheme } from "../../Context/ThemeContext";
import { lightTheme, darkTheme } from "../../Styles/theme";
import { organizationRanking, calcLegacyRanking } from "../../Exercise/Transaction/Transaction";
import LegacyRankingBox from '../../Exercise/Model/Legacy/LegacyRankingBox';
import FetchModule from "../../Model/Share/Network/FetchModule";
import UserProfile from '../../Component/Normal/UserProfile';

import { ReactComponent as RankFirstSvg } from '../../image/RankFirst.svg';
import { ReactComponent as RankSecondSvg } from '../../image/RankSecond.svg';
import { ReactComponent as RankThirdSvg } from '../../image/RankThird.svg';
import { ReactComponent as LeftArrowSvg } from '../../image/LeftArrow.svg';
import DefaultProfile from '../../image/DefaultProfile.png';
import { ReactComponent as BlackExitSvg } from '../../image/BlackExit.svg';


export default function MainPageRankingView(props) {
  const {
    nowSection,
    setNowSection,
    onClickLegacyRankingBox,
    selectedWod,
    isClickedRanking,
    onClickGoBack,
    isMainView = false
  } = props;

  const { t } = useLanguage();
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  const [legacyRankingData, setLegacyRankingData] = useState([]);
  const [legacyUseData, setLegacyUseData] = useState([]);

  const [rankingData, setRankingData] = useState([]);
  const [finalRank, setFinalRank] = useState([]);
  const [division, setDivision] = useState('Total');


  // Ranking Data API Call //
  useEffect(() => {
    if (selectedWod === undefined || !isClickedRanking) {
      setRankingData([]);
      return;
    }

    // 신버전 랭킹 데이터 불러오기 //
    if (selectedWod.wodVersion === 2) {
      const fetchModule = new FetchModule();
      (
        async () => {
          let responseData = await fetchModule.getDataOfExerciseVersion2('record/' + selectedWod.workoutId, 'GET');
          if (responseData.status === 200) {
            setRankingData(responseData.data.sectionRank);
          }
        }
      )();
    }
    else {
      let requestData = {
        workoutId: selectedWod.workoutId
      }

      const fetchModule = new FetchModule();
      (
        async () => {
          let responseData = await fetchModule.postDataOfExerciseVersion2('workout/tmp/ranking', 'POST', requestData);
          if (responseData.status === 200) {
            let workoutData = responseData.data.slice();

            setLegacyUseData(organizationRanking(workoutData));
          }
          else if (responseData.status === 204) setLegacyUseData([]);
        }
      )();
    }
  }, [selectedWod, isClickedRanking])

  // 옛날버전 랭킹 산정 //
  useEffect(() => {
    if (legacyUseData.length === 0) {
      setLegacyRankingData([]);
      return;
    }

    let legacyRanking = calcLegacyRanking(legacyUseData, nowSection);

    setLegacyRankingData(legacyRanking);
  }, [legacyUseData, nowSection])

  // 새로운 버전 랭킹 구분 정리 //
  useEffect(() => {
    if (rankingData.length === 0 || nowSection === undefined) {
      setFinalRank([]);
      return;
    }

    let newList = [];

    if (division === 'Total') {
      newList = rankingData[nowSection].sectionRecords.slice();
    }
    for (let i = 0; i < rankingData[nowSection].sectionRecords.length; i++) {
      if (rankingData[nowSection].sectionRecords[i].gender === division) newList.push(rankingData[nowSection].sectionRecords[i]);
    }
    setFinalRank(newList);
  }, [rankingData, nowSection, division])


  // 한자리 숫자 앞에 0 붙이기 //
  function numberPad(n, width) {
    n = n + '';
    return n.length >= width ? n : new Array(width - n.length + 1).join('0') + n;
  }

  // 점수 보여주기 //
  function onViewFinalScoreText(data) {
    if (data.tag === 'ForTime') {
      if (data.success === 'Success') {
        let min = parseInt(data.recordTime / 60);
        let sec = parseInt(data.recordTime % 60);

        return (
          <RowTextWrapper>
            <Text style={{ marginRight: 6 }} fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text}>{numberPad(min, 2) + ':' + numberPad(sec, 2)}</Text>
            <Text style={{ marginRight: 6 }} fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText}>Time</Text>
            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text}>{data.scoreText}</Text>
          </RowTextWrapper>
        )
      }
      else {
        return (
          <RowTextWrapper>
            <Text style={{ marginRight: 2 }} fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text}>{data.completeRound}</Text>
            <Text style={{ marginRight: 6 }} fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText}>R</Text>
            <Text style={{ marginRight: 2 }} fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text}>{data.lastRound}</Text>
            <Text style={{ marginRight: 6 }} fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText}>Reps</Text>
            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text}>{data.scoreText}</Text>
          </RowTextWrapper>
        )
      }
    }
    else if (data.tag === 'AMRAP') {
      return (
        <RowTextWrapper>
          <Text style={{ marginRight: 2 }} fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text}>{data.completeRound}</Text>
          <Text style={{ marginRight: 6 }} fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText}>R</Text>
          <Text style={{ marginRight: 2 }} fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text}>{data.lastRound}</Text>
          <Text style={{ marginRight: 6 }} fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText}>Reps</Text>
          <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text}>{data.scoreText}</Text>
        </RowTextWrapper>
      )
    }
    else if (data.tag === 'SINGLE') {
      return (
        <RowTextWrapper>
          <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text}>{data.scoreText}</Text>
        </RowTextWrapper>
      )
    }
    else if (data.tag === 'EMOM' || data.tag === 'TABATA') {
      return (
        <RowTextWrapper >
          <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text}>{data.scoreText}</Text>
        </RowTextWrapper>
      )
    }
    else if (data.tag === 'Custom') {
      if (data.scoreKeyword === 'Not Scored') {
        return (
          <RowTextWrapper>
            <NotScoredBox isSuccess={data.success === 'Success'}>
              <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.white}>{data.success === 'Success' ? t('board.exerciseComplete') : t('board.exerciseNotDone')}</Text>
            </NotScoredBox>
          </RowTextWrapper>
        )
      }
      else if (data.scoreKeyword === 'Time') {
        let min = parseInt(data.recordTime / 60);
        let sec = parseInt(data.recordTime % 60);

        return (
          <RowTextWrapper>
            <Text style={{ marginRight: 6 }} fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text}>{numberPad(min, 2) + ':' + numberPad(sec, 2)}</Text>
            <Text style={{ marginRight: 6 }} fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText}>Time</Text>
            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text}>{data.scoreText}</Text>
          </RowTextWrapper>
        )
      }
      else if (data.scoreKeyword === 'Rounds And Reps') {
        return (
          <RowTextWrapper>
            <Text style={{ marginRight: 2 }} fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text}>{data.customLastRound}</Text>
            <Text style={{ marginRight: 6 }} fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText}>R</Text>
            <Text style={{ marginRight: 2 }} fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text}>{data.customLastReps}</Text>
            <Text style={{ marginRight: 6 }} fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText}>Reps</Text>
            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text}>{data.scoreText}</Text>
          </RowTextWrapper>
        )
      }
      else if (data.scoreKeyword === 'Reps'
        || data.scoreKeyword === 'Distance'
        || data.scoreKeyword === 'Weight'
        || data.scoreKeyword === 'Points'
        || data.scoreKeyword === 'Peak Watts'
        || data.scoreKeyword === 'Max Speed'
      ) {
        return (
          <RowTextWrapper>
            <Text style={{ marginRight: 6 }} fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text}>{data.customKeywordValue}</Text>
            <Text style={{ marginRight: 6 }} fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText}>{data.customKeywordUnit}</Text>
            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text}>{data.scoreText}</Text>
          </RowTextWrapper>
        )
      }
    }
  }

  return (
    <TotalRankingBoxWrapper>
      {
        (selectedWod !== undefined) &&
        <RankingBoxWrapper isMainView={isMainView} >
          <RankingWodSectionButtonWrapper>
            <WodSectionButtonWrapper>
              {
                selectedWod.sectionList.map((_, index) => (
                  <WodSectionButton key={'WodSection-' + index} isClicked={nowSection === index} onClick={() => setNowSection(index)}>
                    <Text fontFamily='NotoSansKR-Bold' fontSize={14} color={nowSection === index ? theme.white : theme.subText} hover='pointer'>{String.fromCharCode(index + 65)}</Text>
                  </WodSectionButton>
                ))
              }
            </WodSectionButtonWrapper>
            <GoBackButton onClick={onClickGoBack}>
              <ExitIcon />
            </GoBackButton>
          </RankingWodSectionButtonWrapper>
          {
            selectedWod.wodVersion === 2 ?
              <RankingViewBox style={{ marginTop: '20px' }} isMainView={isMainView} >
                <DivisionWrapper>
                  <TotalDivisionBox isClicked={division === 'Total'} onClick={() => setDivision('Total')}>
                    <Text fontFamily='NotoSansKR-Bold' fontSize={14} color={theme.white} hover='pointer'>{t('board.divisionTotal')}</Text>
                  </TotalDivisionBox>
                  <FemaleDivisionBox isClicked={division === 'Female'} onClick={() => setDivision('Female')}>
                    <Text fontFamily='NotoSansKR-Bold' fontSize={14} color={theme.white} hover='pointer'>{t('board.divisionFemale')}</Text>
                  </FemaleDivisionBox>
                  <MaleDivisionBox isClicked={division === 'Male'} onClick={() => setDivision('Male')}>
                    <Text fontFamily='NotoSansKR-Bold' fontSize={14} color={theme.white} hover='pointer'>{t('board.divisionMale')}</Text>
                  </MaleDivisionBox>
                </DivisionWrapper>
                <NewPrevRankingViewInnerWrapper>
                  <TotalRankingViewWrapper>
                  {
                    finalRank.map((data, index) => (
                      <RankingViewWrapper key={'Ranking-' + index}>
                        <RankingNumberBoxWrapper>
                          {
                            (index >= 0 && index < 3) ?
                              <RankingLeaderBoxWrapper>
                                {index === 0 ? <RankFirstIcon /> : index === 1 ? <RankSecondIcon /> : <RankThirdIcon />}
                                <RankingImageTextWrapper>
                                  <Text fontFamily='NotoSansKR-Bold' fontSize={14} color={theme.white}>{index + 1}</Text>
                                </RankingImageTextWrapper>
                              </RankingLeaderBoxWrapper>
                              :
                              <RankingNumberBox>
                                <Text fontFamily='NotoSansKR-Bold' fontSize={14} color={theme.white}>{index + 1}</Text>
                              </RankingNumberBox>
                          }
                        </RankingNumberBoxWrapper>
                        <RankingClickBox>
                          <InfoBox>
                            <LeftWrapper>
                              <ProfileWrapper>
                                <UserProfile profile={data.userProfile} defaultProfile={DefaultProfile} />
                              </ProfileWrapper>
                              <InfoTextWrapper>
                                <InfoRowTextWrapper>
                                  <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text}>{data.userName}</Text>
                                  {
                                    (data.derivationSectionId !== undefined) &&
                                    <ScaleBox>
                                      <Text fontFamily='Poppins-Medium' fontSize={12} color={theme.white}>{String.fromCharCode(nowSection + 65) + '-' + (data.scaleSectionIndex + 1)}</Text>
                                    </ScaleBox>
                                  }
                                </InfoRowTextWrapper>
                                <ScoreTextWrapper>
                                  <Text style={{ textOverflow: 'ellipsis', whiteSpace: 'nowrap'}} fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.line}>{onViewFinalScoreText(data)}</Text>
                                </ScoreTextWrapper>
                              </InfoTextWrapper>
                            </LeftWrapper>
                          </InfoBox>
                        </RankingClickBox>
                      </RankingViewWrapper>
                    ))
                  }
                  </TotalRankingViewWrapper>
                </NewPrevRankingViewInnerWrapper>
              </RankingViewBox>
              :
              <RankingViewBox style={{ marginTop: '26px' }}>
                <PrevRankingViewInnerWrapper>
                  <LegacyRankingBox
                    sectionData={legacyUseData.length > 0 ? legacyUseData[0].sectionList : null}
                    rankingList={legacyRankingData}
                    onClickRankingBox={onClickLegacyRankingBox} />
                </PrevRankingViewInnerWrapper>
              </RankingViewBox>
          }
        </RankingBoxWrapper>
      }
    </TotalRankingBoxWrapper>
  )
}


const TotalRankingBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  width: 100%;
  height: 100%;

  transition: all 0.3s ease-in-out;
`;

const RankingBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  flex: 1;
  width: 100%;

  overflow-x: hidden;

  border-radius: 20px 20px 20px 20px;
  background-color: ${props => props.isMainView ? props.theme.subBackground : props.theme.background};

  transition: all 0.3s ease-in-out;
`;

const RankingWodSectionButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-item: center;

  padding: 0px 10px 0 20px;
  margin-top: 10px;

  width: calc(100% - 30px);
`;

const WodSectionButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-item: center;

  width: 100%;

  gap: 8px;
`;

const WodSectionButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 32px;
  height: 32px;

  border-radius: 6px;
  background-color: ${props => props.isClicked ? props.theme.subKey : props.theme.buttonFill};

  transition: all 0.3s ease-in-out;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const GoBackButton = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 30px;
  height: 30px;

  transition: all 0.3s ease-in-out;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const RankingViewBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  width: 100%;
  height: calc(100% - 57px);

  overflow: hidden;

  outline: none;

  background-color: ${props => props.isMainView ? props.theme.subBackground : props.theme.background};

  transition: all 0.3s ease-in-out;
`;

const DivisionWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 100%;

  transition: all 0.3s ease-in-out;
`;

const TotalDivisionBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 100%;
  height: 31px;

  border-top-left-radius: 15px;
  border-top-right-radius: 15px;

  background-color: ${props => props.isClicked ? props.theme.pointYellow : props.theme.line};

  transition: all 0.3s ease-in-out;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const FemaleDivisionBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 100%;
  height: 31px;

  border-top-left-radius: 15px;
  border-top-right-radius: 15px;

  background-color: ${props => props.isClicked ? props.theme.primary : props.theme.line};

  transition: all 0.3s ease-in-out;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const MaleDivisionBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 100%;
  height: 31px;

  border-top-left-radius: 15px;
  border-top-right-radius: 15px;

  background-color: ${props => props.isClicked ? props.theme.pointBlue : props.theme.line};

  transition: all 0.3s ease-in-out;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const PrevRankingViewInnerWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  width: 100%;

  overflow-x: hidden;
  overflow-y: scroll;

  &::-webkit-scrollbar {
    width: 0px;
    height: 0px;
  }

  &::-webkit-scrollbar-thumb {
    border: 0px solid transparent;
    background-color: ${props => props.theme.line};
    border-radius: 2px;
  }

  &::-webkit-scrollbar-track {
    border-radius: 200px;
    opacity: 0;
  }
`;

const NewPrevRankingViewInnerWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  padding: 10px 0px 15px 0px;

  box-sizing: border-box;
  width: 100%;

  gap: 10px;

  overflow-x: hidden;
  overflow-y: scroll;

  &::-webkit-scrollbar {
    width: 0px;
    height: 0px;
  }

  &::-webkit-scrollbar-thumb {
    border: 0px solid transparent;
    background-color: ${props => props.theme.line};
    border-radius: 2px;
  }

  &::-webkit-scrollbar-track {
    border-radius: 200px;
    opacity: 0;
  }

  transition: all 0.3s ease-in-out;
`;

const ScoreTextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;
  height: 20px;

  overflow: hidden;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: ${props => props.hover};
    }
  }

  transition: all 0.3s ease-in-out;
`;


const TotalRankingViewWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  box-sizing: border-box;
  width: 100%;
  height: 100%;

  gap: 10px;

  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  &::-webkit-scrollbar-thumb {
    border: 0px solid transparent;
    background-color: ${props => props.theme.line};
    border-radius: 2px;
  }

  &::-webkit-scrollbar-track {
    border-radius: 200px;
    opacity: 0;
  }
`;

const RankingViewWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: flex-start;

  padding: 5px 20px;

  box-sizing: border-box;
  width: 443px;
  height: 81px;

  gap: 5px;
`;

const RankingNumberBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;
`;

const RankingLeaderBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;
`;

const RankFirstIcon = styled(RankFirstSvg)`
  width: 40px;
  height: 40px;
`;

const RankSecondIcon = styled(RankSecondSvg)`
  width: 40px;
  height: 40px;
`;

const RankThirdIcon = styled(RankThirdSvg)`
  width: 40px;
  height: 40px;
`;

const RankingImageTextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin-top: -34.5px;
`;

const RankingNumberBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 40px;
  height: 40px;

  border-radius: 12px;
  background-color: ${props => props.theme.buttonFill3};

  transition: all 0.3s ease-in-out;
`;

const RankingClickBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: 12px;

  box-sizing: border-box;
  width: 100%;
  height: 71px;

  border-radius: 12px;
  background-color: ${props => props.theme.subBackground};

  transition: all 0.3s ease-in-out;
`;

const InfoBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
`;

const LeftWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 8px;
`;

const ProfileWrapper = styled.div`
  width: 47px;
  height: 47px;

  border-radius: 5px;

  overflow: hidden;

  & img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }
`;

const InfoTextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  min-width: 0;

  gap: 3px;
`;

const InfoRowTextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 8px;
`;

const DetailIconWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  padding: 14px 11px;
`;

const DetailIcon = styled(LeftArrowSvg)`
  flex-shrink: 0;
  width: 10px;
  height: 18px;

  transform: rotate(180deg);

  & path {
    fill: ${props => props.theme.subText};
  }

  transition: all 0.3s ease-in-out;
`;

const RowTextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  width: 100%;
`;


const NotScoredBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  padding: 0px 10px;

  height: 20px;

  border-radius: 6px;
  background-color: ${props => props.isSuccess ? props.theme.subKey : props.theme.pointRed};

  transition: all 0.3s ease-in-out;
`;

const ScaleBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  margin-left: 4px;
  padding: 1px 10px;

  border-radius: 5px;
  background-color: ${props => props.theme.pointBlue};

  transition: all 0.3s ease-in-out;
`;

const ExitIcon = styled(BlackExitSvg)`
  width: 23px;
  height: 23px;

  color: ${props => props.theme.line};
  transition: color 0.3s ease-in-out;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      color: ${props => props.theme.primary};
      cursor: pointer;
    }
  }
`;
